import classNames from 'classnames/bind';
import styles from './SaladsPage.module.scss';
import ButtonFoodOrder from '~/components/specific/buttonFoodOrder/ButtonFoodOrder';
import { ButtonFoodOrderTouch, SelectBox } from '~/components/specific';
import {
  dataFilterSalads,
  optionsSalads,
  optionsSubs,
  toppingPizza,
  toppingPizzaTouch,
} from '~/utils/constants/mockData';
import { IItemSelected, IToppingItemSelected } from '~/utils/interface/common';
import { KeyOptionOrderEnum, NameSelectBoxHeaderSaladsEnum } from '~/utils/enum';
import { useDispatch, useSelector } from 'react-redux';
import { orderActions, selectOrder } from '~/sagas/order/slice';
import { useState } from 'react';
import { IItemOrder } from '~/sagas/order/state';

interface Props {}

const cx = classNames.bind(styles);

const SaladsPage = (props: Props) => {
  const dispatch = useDispatch();
  const isTouchScreen = JSON.parse(localStorage.getItem('isTouchScreen') ?? 'false');
  const orderSelector = useSelector(selectOrder);
  const [sizeSelected, setSizeSelected] = useState<string>('Regular');

  const handleChangeSalad = (itemSelected: IItemSelected) => {
    const flatbreadSelected: IItemOrder = {
      id: Date.now(),
      name: itemSelected.value,
      size: sizeSelected,
      money: sizeSelected === 'Regular' ? 8 : 10,
      type: KeyOptionOrderEnum.SALADS,
      quantity: 1,
      toping: [],
    };
    dispatch(orderActions.addToOrder(flatbreadSelected));
  };

  const handleChangeSize = (itemSelected: IItemSelected) => {
    const id = orderSelector[0]?.id;
    if (!id) {
      return;
    }
    if (orderSelector[0].type === KeyOptionOrderEnum.SALADS) {
      // TODO handle logic
      const payloadUpdate = {
        id: id,
        newSize: itemSelected.value,
        money: itemSelected.value === 'Regular' ? 8 : 10,
      };
      dispatch(orderActions.updateSizeItem(payloadUpdate));
      setSizeSelected(itemSelected.value);
    }
  };

  const handleChangeCheese = (itemSelected: IItemSelected) => {
    // TODO: Handle logic
  };

  const handleChangeDressing = (itemSelected: IItemSelected) => {
    // TODO: Handle logic
  };

  const handleSelectedItem = (itemSelected: IItemSelected) => {
    if (itemSelected.id === -1) {
      return;
    }
    switch (itemSelected.nameSelectBox) {
      case NameSelectBoxHeaderSaladsEnum.SALAD:
        handleChangeSalad(itemSelected);
        break;
      case NameSelectBoxHeaderSaladsEnum.SIZE:
        handleChangeSize(itemSelected);
        break;
      case NameSelectBoxHeaderSaladsEnum.CHEESE:
        handleChangeCheese(itemSelected);
        break;
      case NameSelectBoxHeaderSaladsEnum.DRESSING:
        handleChangeDressing(itemSelected);
        break;
    }
  };

  const handleChangeTopping = (itemSelected: IToppingItemSelected) => {
    const id = orderSelector[0]?.id;
    if (!id) {
      return;
    }
    if (!itemSelected.value) {
      const itemTopingRemove = orderSelector[0].toping.find(
        (t: any) => t.position === itemSelected.position && t.title === itemSelected.title
      );
      if (!itemTopingRemove) {
        return;
      }

      const payloadRemoveToping = {
        id: id,
        idToping: itemTopingRemove.id,
      };
      dispatch(orderActions.removeTopingOrder(payloadRemoveToping));
      return;
    }
    const dataAddToping = {
      id: id,
      newToping: {
        id: Date.now(),
        position: itemSelected.position,
        quantity: itemSelected.value,
        name: `${itemSelected.value} ${itemSelected.position} ${itemSelected.title}`,
        title: itemSelected.title,
        money: 2,
      },
    };
    const topingExited = orderSelector[0].toping.find(
      (t: any) => t.title === itemSelected.title && t.position === itemSelected.position
    );
    if (topingExited) {
      dispatch(orderActions.updateTopingOrder(dataAddToping));
      return;
    }
    dispatch(orderActions.addTopingOrder(dataAddToping));
  };

  return (
    <div className={cx('page-container')}>
      <div className={cx('page-head-wrap')}>
        {dataFilterSalads.map((item) => {
          const itemDefault = item.data.find((x) => x.id === item.defaultValue);

          return (
            <SelectBox
              key={item.id}
              name={item.name}
              data={item.data}
              defaultValue={itemDefault}
              onChange={handleSelectedItem}
            />
          );
        })}
      </div>

      <div className={cx('page-divide-line')} />

      {isTouchScreen ? (
        <div className={cx('page-body-wrap')}>
          {optionsSalads.map((item) => (
            <ButtonFoodOrderTouch
              toppingItem={item}
              isActive={false}
              data={toppingPizzaTouch}
              key={item.id}
              onChange={handleChangeTopping}
            />
          ))}
        </div>
      ) : (
        <div className={cx('page-body-wrap')}>
          {optionsSalads.map((item) => (
            <ButtonFoodOrder
              toppingItem={item}
              isActive={true}
              data={toppingPizza}
              key={item.id}
              onChange={handleChangeTopping}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default SaladsPage;
